export const setValidLogin = state => {
    return dispatch => {
        dispatch({ type: "SET_VALID_LOGIN", payload: state });
    }
}